import { createAction } from "redux-smart-actions";
import { takeLatest } from "@redux-saga/core/effects";
import {
  Customer,
  DocumentType,
  Offer,
  OfferDemandedDocument,
  OfferRevision,
} from "./types";
import { postSaga, PostSagaGenericParams } from "../base/postSaga";
import { SagaActionParams } from "../base/types/saga";
import { getListSaga } from "../base/getListSaga";
import { updateSaga } from "../base/updateSaga";

export const createOffer = createAction(
  "CREATE_OFFER",
  ({ payload, url, body }: SagaActionParams<Offer>) => ({
    payload,
    url,
    body,
  })
);
export const createOfferRevision = createAction(
  "CREATE_OFFER_REVISION",
  ({ payload, url, body }: SagaActionParams<Offer>) => ({
    payload,
    url,
    body,
  })
);
export const createCustomer = createAction(
  "CREATE_CUSTOMER",
  ({ payload, url, body }: SagaActionParams<Customer>) => ({
    payload,
    url,
    body,
  })
);
export const getOfferDetails = createAction(
  "GET_OFFER_DETAILS",
  ({ payload, url }: SagaActionParams<Offer>) => ({
    payload,
    url,
  })
);
export const getOfferDocuments = createAction(
  "GET_OFFER_DOCUMENTS",
  ({ payload, url }: SagaActionParams<OfferDemandedDocument[]>) => ({
    payload,
    url,
  })
);
export const getDocumentTypes = createAction(
  "GET_DOCUMENT_TYPES",
  ({ payload, url }: SagaActionParams<DocumentType[]>) => ({
    payload,
    url,
  })
);

export const getOfferPdf = createAction(
  "GET_OFFER_PDF",
  ({ payload, url }: SagaActionParams<string>) => ({
    payload,
    url,
  })
);
export const sendWelcomeEmail = createAction(
  "SEND_WELCOME_EMAIL",
  ({ payload, url }: SagaActionParams<any>) => ({
    payload,
    url,
  })
);
export const uploadDocument = createAction(
  "UPLOAD_DOCUMENT",
  ({ payload, url, body }: SagaActionParams<any>) => ({
    payload,
    url,
    body,
  })
);
const offerSaga = [
  takeLatest(
    createCustomer.toString(),
    (payload: PostSagaGenericParams<Customer>) => postSaga<Customer>(payload)
  ),
  takeLatest(createOffer.toString(), (payload: PostSagaGenericParams<Offer>) =>
    postSaga<Offer>(payload)
  ),
  takeLatest(
    createOfferRevision.toString(),
    (payload: PostSagaGenericParams<OfferRevision>) =>
      postSaga<OfferRevision>(payload)
  ),
  takeLatest(
    getOfferDetails.toString(),
    (payload: PostSagaGenericParams<Offer>) => getListSaga<Offer>(payload)
  ),
  takeLatest(
    getOfferDocuments.toString(),
    (payload: PostSagaGenericParams<OfferDemandedDocument[]>) =>
      getListSaga<OfferDemandedDocument[]>(payload)
  ),
  takeLatest(
    getDocumentTypes.toString(),
    (payload: PostSagaGenericParams<DocumentType[]>) =>
      getListSaga<DocumentType[]>(payload)
  ),
  takeLatest(uploadDocument.toString(), (payload: PostSagaGenericParams<any>) =>
    updateSaga<any>(payload)
  ),
  takeLatest(getOfferPdf.toString(), (payload: PostSagaGenericParams<string>) =>
    getListSaga<string>(payload)
  ),
  takeLatest(
    sendWelcomeEmail.toString(),
    (payload: PostSagaGenericParams<any>) => getListSaga<any>(payload)
  ),
];

export default offerSaga;
